module.exports = __webpack_public_path__ + "media/appointed.d46d7db1.mp3";